// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.brewcontrol_node_status_enum */
var BrewcontrolNodeStatusEnum;
(function (BrewcontrolNodeStatusEnum) {
    BrewcontrolNodeStatusEnum["pending"] = "pending";
    BrewcontrolNodeStatusEnum["active"] = "active";
    BrewcontrolNodeStatusEnum["revoked"] = "revoked";
})(BrewcontrolNodeStatusEnum || (BrewcontrolNodeStatusEnum = {}));
;
export default BrewcontrolNodeStatusEnum;
/** Zod schema for brewcontrol_node_status_enum */
export const brewcontrolNodeStatusEnum = z.nativeEnum(BrewcontrolNodeStatusEnum);
//# sourceMappingURL=BrewcontrolNodeStatusEnum.js.map